<style scoped lang="sass">
#tournament-leaderboard
  margin-top: 1rem
  padding: 0 var(--base-padding)
.row
  cursor: pointer
.column
  img
    width: 22px
    height: 22px
    border-radius: 11px
  &:nth-child(1)
    flex: 0 0 1.5rem !important
    padding: 0 !important
  &:nth-child(2)
    flex-grow: 3 !important
</style>
<template>
  <div id="tournament-leaderboard">
    <pinhigh-table
        :headers="['', '', 'POS', 'TOT', 'RD', 'THRU']"
        :rows="pool.tournament.tournament_players"
      >
      <template slot="headers" slot-scope="props">
        <div class="column" v-for="(header,i) in props.headers" :key="i">{{header}}</div>
      </template>
      <template slot="row" slot-scope="props">
        <div class="row" @click.prevent="openScorecardModal(props.row)">
          <div class="column"><img :src="props.row.image_url" /></div>
          <div class="column"><div class="ellipsis-overflow">{{props.row.player_id}}</div></div>
          <div class="column">{{props.row.position | pinhighDisplayPlayerPosition({tie: props.row.tie, status: props.row.status})}}</div>
          <div class="column">{{props.row.net_score | pinhighDisplayTotalStrokes}}</div>
          <div class="column">{{props.row.net_today | pinhighDisplayTotalStrokes}}</div>
          <div class="column">{{props.row.today_through | pinhighDisplayThrough}}</div>
        </div>
      </template>
    </pinhigh-table>
    <scorecard-modal v-if="scorecardModal" :on-close="closeScorecardModal" :tournament-player="scorecardModal"></scorecard-modal>
  </div>
</template>
<script>
import ordinal from 'ordinal';

import ScorecardModal from './scorecard-modal.vue';

export default {
  name: 'TournamentLeaderboard',
  components: {
    ScorecardModal
  },
  props: {
    pool: Object
  },
  data() {
    return {
      scorecardModal: null
    };
  },
  methods: {
    ordinal,
    openScorecardModal(tournamentPlayer) {
      this.scorecardModal = tournamentPlayer;
    },
    closeScorecardModal() {
      this.scorecardModal = null;
    }
  }
};
</script>
